/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Home_Greeting_MorningInputs */



/**
* | output |
* | --- |
* | "Good morning, {name}!" |
*
* @param {Home_Greeting_MorningInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const home_greeting_morning = /** @type {((inputs: Home_Greeting_MorningInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Greeting_MorningInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Guten Morgen, ${i?.name}!`)
	return /** @type {LocalizedString} */ (`Good morning, ${i?.name}!`)
});